// ============================================================================
// clock.js — fixed-timestep accumulator. Logic runs at a rock-steady 60 Hz
// regardless of render frame-rate; render interpolates by `alpha`.
// ============================================================================

import { TICK_DT, MAX_SUBSTEPS } from './constants.js';

export class FixedClock {
  constructor(dt = TICK_DT, maxSub = MAX_SUBSTEPS) {
    this.dt = dt;
    this.maxSub = maxSub;
    this.acc = 0;
    this.last = -1;
    this.alpha = 0;      // fractional progress into the next tick, for render lerp
    this.simTime = 0;    // total simulated seconds (advances only on real steps)
    this.frameDt = 0;    // last real frame delta (for render-only smoothing)
  }

  /**
   * Advance using the current wall-clock time in seconds.
   * @returns {number} how many fixed logic steps to run this frame.
   */
  update(nowSec) {
    if (this.last < 0) this.last = nowSec;
    let frame = nowSec - this.last;
    this.last = nowSec;
    if (frame > 0.25) frame = 0.25;   // clamp long stalls (tab hidden) — no spiral
    if (frame < 0) frame = 0;
    this.frameDt = frame;
    this.acc += frame;

    let steps = 0;
    while (this.acc >= this.dt && steps < this.maxSub) {
      this.acc -= this.dt;
      steps++;
    }
    // If we saturated the substep budget, shed the backlog so we don't spiral.
    if (steps === this.maxSub && this.acc > this.dt) this.acc = 0;

    this.simTime += steps * this.dt;
    this.alpha = this.acc / this.dt;
    return steps;
  }
}
